import styled from 'styled-components'

export const TypographContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 24px 32px 8px 32px;
`
export const QrcodeImage = styled.img`
    width: 100px;
    height: 100px;
    min-width: 100px;
`
